// Map accented chars to their base char and tone number
const TONE_MAP: Record<string, [string, number]> = {
  // a
  ā: ['a', 1],
  á: ['a', 2],
  ǎ: ['a', 3],
  à: ['a', 4],
  // e
  ē: ['e', 1],
  é: ['e', 2],
  ě: ['e', 3],
  è: ['e', 4],
  // i
  ī: ['i', 1],
  í: ['i', 2],
  ǐ: ['i', 3],
  ì: ['i', 4],
  // o
  ō: ['o', 1],
  ó: ['o', 2],
  ǒ: ['o', 3],
  ò: ['o', 4],
  // u
  ū: ['u', 1],
  ú: ['u', 2],
  ǔ: ['u', 3],
  ù: ['u', 4],
  // v / ü (handling ü as v or u depending on your DB preference, usually v or ü)
  ǖ: ['v', 1],
  ǘ: ['v', 2],
  ǚ: ['v', 3],
  ǜ: ['v', 4],
  ü: ['v', 0]
}

/**
 * Converts accented pinyin to numbered pinyin format.
 * Example: "shàng shǒu" -> "shang4 shou3"
 */
export function convertAccentedPinyinToNumbered(input: string): string {
  const raw = input.trim()

  // Process word-by-word to handle "shàng shǒu" -> "shang4 shou3"
  const tokens = raw.toLowerCase().split(/\s+/)

  const numTokens = tokens.map((token) => {
    // If token already has numbers ("shi4"), leave it
    if (/\d/.test(token)) return token

    let hasTone = false
    let toneNum = 0
    let baseStr = ''

    // Check each char for an accent
    for (const char of token) {
      if (TONE_MAP[char]) {
        baseStr += TONE_MAP[char][0] // Add clean char
        toneNum = TONE_MAP[char][1] // Capture tone
        hasTone = true
      } else {
        baseStr += char
      }
    }

    // If we found a tone accent, append the number to the end of the token
    // "shàng" -> "shang" + "4"
    if (hasTone && toneNum > 0) {
      return baseStr + toneNum
    }

    // Fallback: If no accent found, return the clean version
    return baseStr
  })

  // "shang4 shou3" or "ni3hao3" (if originally typed as ni3hao3)
  return numTokens
    .join(' ')
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
}

export default function convertAccentsToNumbers(text: string): string {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
